import styled from 'styled-components'

export const FieldsStyled = styled.div`
  display: flex;
  flex-direction: column;
  [aria-disabled='true'] .react-select__single-value {
    color: ${(props) => props.theme.colors.textSecondary};
  }
`
